import { snakeCase } from 'lodash';
import { getCdnBaseUrl } from '@/config/env-config';

/**
 * Build full CDN URL for icon paths.
 * Prepends CDN base URL for relative paths (starting with /).
 */
export function buildIconUrl(
  iconPath: string | null | undefined
): string | undefined {
  if (!iconPath) {
    return undefined;
  }

  return iconPath.startsWith('/') ? `${getCdnBaseUrl()}${iconPath}` : iconPath;
}

/**
 * Build CDN icon URL from application display name.
 * Used when no vendor logo (icon_path) is set.
 * @example 'Admin Console' -> 'https://cdn.../icons/admin_console_icon.svg'
 */
export function getAppIconUrlByName(appName: string): string {
  const iconName = snakeCase(appName);

  return `${getCdnBaseUrl()}/icons/${iconName}_icon.svg`;
}

/**
 * Resolve the icon URL to display for an application.
 * Uses vendor logo (icon_path) when available, otherwise CDN icon by name.
 *
 * @param iconPath - Optional vendor logo path or full URL from API.
 * @param appName - Display name used to build fallback CDN URL when iconPath is missing or empty.
 */
export function getApplicationIconUrl(
  iconPath: string | null | undefined,
  appName: string
): string {
  const url = buildIconUrl(iconPath);

  return url ?? getAppIconUrlByName(appName);
}
